import React from 'react'
import { Button, ButtonGroup, Dropdown, SplitButton } from 'react-bootstrap'
import OnHoverTooltip from "../../../../components/tables/shared/OnHoverTooltip"
import ExlMailCalendarIcons from '../../../../components/exl/icons/ExlMailCalendarIcons';
import { useTranslation } from 'react-i18next';
import { EMAIL_NOTIFICATIONS_FALSE, EMAIL_NOTIFICATIONS_TRUE, LECTURE_DETAILS_HEADER_EDIT_ATTENDANCE, LECTURE_DETAILS_HEADER_EDIT_LECTURE, LECTURE_DETAILS_HEADER_NO_PARTICIPANTS, LECTURE_DETAILS_HEADER_DELETE_LECTURE } from '../../../../i18n/keyConstants';

const LectureActions = ({
  setDeleteLectureModalOpen,
  setEditLectureModalOpen,
  setEditLectureAttendancesModalOpen,
  lectureUser,
  lecture
}) => {

  const { t } = useTranslation(['lectureDetailsHeader', 'shared']);

  return (
    <div className='flex-wrap course-actions' style={{ display: "flex", gap: "8px" }}>
      {(lectureUser.teacherPermission || lectureUser.editPermission) && (
        <> 
          <div style={{  display: "flex", display: 'inline-block'}  }>
            <ExlMailCalendarIcons 
              sendEmailNotifications={lecture.course.sendEmailNotifications}
              trueText={t(EMAIL_NOTIFICATIONS_TRUE, {ns: 'shared'})}
              falseText={t(EMAIL_NOTIFICATIONS_FALSE, { ns: 'shared' })}
              />
          </div>

          <Dropdown as={ButtonGroup}>
            <Button variant="info" onClick={() => setEditLectureModalOpen(true)}>{t(LECTURE_DETAILS_HEADER_EDIT_LECTURE)}</Button>
            <Dropdown.Toggle split variant="info" id="dropdown-split-basic" />
            <Dropdown.Menu>

            {lecture.course.bookings.length < 1 ? //prevents editing of bookings if no lectures are created to avoid bookings with no dates}
              <OnHoverTooltip
                labelClassNames='d-flex margin-none'
                tooltipType='dark'
                tooltipPlace='left'
                tooltipEffect='solid'>

              <Dropdown.Item
                eventKey="1"
                onClick={() => setEditLectureAttendancesModalOpen(true)}
                disabled={lecture.course.bookings.length < 1 ? true : false}
                className={lecture.course.bookings.length < 1 ? "text-muted" : ""}>
              {t(LECTURE_DETAILS_HEADER_EDIT_ATTENDANCE)}
              </Dropdown.Item>
              <span className='d-flex my-auto' style={{ width: 80 }}>{t(LECTURE_DETAILS_HEADER_NO_PARTICIPANTS)}</span>
              </OnHoverTooltip>
              :
              <Dropdown.Item
                eventKey="1"
                onClick={() => setEditLectureAttendancesModalOpen(true)}>
                {t(LECTURE_DETAILS_HEADER_EDIT_ATTENDANCE)}
              </Dropdown.Item>
            }
            
            {lectureUser.editPermission && (
              <Dropdown.Item
                eventKey="2"
                onClick={() => setDeleteLectureModalOpen(true)}>
                {t(LECTURE_DETAILS_HEADER_DELETE_LECTURE)}
                </Dropdown.Item>
            )}

            </Dropdown.Menu>
          </Dropdown>

        </>
      )}
    </div>
  )
}

export default function LectureDetailsHeader({
  lecture,
  lectureUser,
  setDeleteLectureModalOpen,
  setEditLectureModalOpen,
  setEditLectureAttendancesModalOpen,
}) {

  const { t } = useTranslation('lectureDetailsHeader');

  return (
    <div 
      className='exl-course-details-header' 
      style={{
        position: "sticky",
        top: 0,
        paddingTop: 24,
        paddingBottom: 24,
        background: "#f5f5f5",
        zIndex: 2,
    }}>
      <div className='exl-course-details-header-name' >
        <h1 style={{ margin: 0, textAlign: "center" }}>{lecture.name}</h1>
      </div>
      <LectureActions
        setDeleteLectureModalOpen={setDeleteLectureModalOpen}
        setEditLectureModalOpen={setEditLectureModalOpen}
        setEditLectureAttendancesModalOpen={setEditLectureAttendancesModalOpen}
        lectureUser={lectureUser}
        lecture={lecture}
      />
    </div>
  )
}
